import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppointmentsListComponent } from '../../components/appointments-list';
import { ShoppingListComponent } from '../../components/shopping-list';

@Component({
  selector: 'hh-kitchen-information-widget',
  standalone: true,
  imports: [CommonModule, ShoppingListComponent, AppointmentsListComponent],
  templateUrl: './kitchen-information-widget.component.html',
  styleUrls: ['./kitchen-information-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KitchenInformationWidgetComponent {
}
